import { render, staticRenderFns } from "./FreeCourseCarousel.vue?vue&type=template&id=22068e4c&scoped=true&"
import script from "./FreeCourseCarousel.vue?vue&type=script&lang=js&"
export * from "./FreeCourseCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22068e4c",
  null
  
)

export default component.exports